import { useTour } from '@reactour/tour'
import { getStepsForRole } from 'lib/tour'
import { useCallback } from 'react'
import { useMediaQuery } from 'react-responsive'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { useBookQuery, useBookRoleQuery } from 'store/queries'
import { breakpoints } from 'style'

export const useDashTour = () => {
  const { pathname } = useLocation()
  const { setIsOpen, setSteps, setCurrentStep } = useTour()
  const history = useHistory()
  const isMobile = useMediaQuery({
    query: `(max-width: ${breakpoints.sm}px)`,
  })

  const match = matchPath(pathname, {
    path: `/dashboard/book/:bookId/*`,
  })
  const bookId = match?.params?.bookId

  const { data: book } = useBookQuery(bookId)
  const { data: role } = useBookRoleQuery(bookId)

  return useCallback(() => {
    if (!book.id) return

    setSteps(
      getStepsForRole(role?.name, isMobile, (path) => {
        history.push(`/dashboard/book/${bookId}${path}`)
      }),
    )
    setCurrentStep(0)
    setIsOpen(true)
  }, [
    book.id,
    role?.name,
    bookId,
    history,
    isMobile,
    setCurrentStep,
    setIsOpen,
    setSteps,
  ])
}
